import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { SEO } from "@/lib/seo";
import { Link } from "react-router-dom";
import { GraduationCap, BookOpen, Award } from "lucide-react";

const TRACKS = [
  { id: "foundational", title: "Foundational", duration: "4 hours", desc: "CAF mission, code of ethics, safety, and community principles.", topics: ["Non-partisan civic action", "Safeguarding on the field", "Data & privacy hygiene", "POSH/POCSO basics"] },
  { id: "advanced", title: "Advanced", duration: "12 hours", desc: "Program design, community mobilisation, monitoring & impact.", topics: ["Community mobilisation", "Program M&E", "Data collection & reporting", "Stakeholder engagement"] },
  { id: "leadership", title: "Leadership", duration: "24 hours + field", desc: "For district and cell leads. Governance, finance, media.", topics: ["Volunteer ops management", "Fundraising fundamentals", "Media, comms & advocacy", "Compliance & governance"] },
];

export default function TrainingPage() {
  return (
    <main>
      <SEO title="Training Resources" description="CAF training tracks for volunteers: Foundational, Advanced and Leadership." breadcrumbs={[{name: "Home", href:"/"},{name:"Training", href:"/training"}]} />
      <PageHeader eyebrow="Training" title="Volunteers who are trained, impact more." lead="Structured tracks with recognition badges. Free for all CAF Digital Members." />
      <section className="container-wide py-12 grid gap-5 md:grid-cols-3">
        {TRACKS.map((t) => (
          <div key={t.id} data-testid={`training-track-${t.id}`} className="rounded-2xl border border-border bg-background p-6 card-lift">
            <div className="h-10 w-10 rounded-md bg-[hsl(var(--surface-tint))] text-foreground grid place-items-center"><GraduationCap className="h-5 w-5" /></div>
            <div className="eyebrow mt-3">Track • {t.duration}</div>
            <h3 className="heading-3 mt-1">{t.title}</h3>
            <p className="text-sm text-[hsl(var(--muted-ink))] mt-2">{t.desc}</p>
            <ul className="mt-3 text-sm space-y-1.5">
              {t.topics.map((x) => (<li key={x} className="flex items-center gap-2 text-foreground"><BookOpen className="h-3.5 w-3.5 text-[hsl(var(--green))]" /> {x}</li>))}
            </ul>
            <div className="mt-4 flex items-center gap-2 text-[11px] text-[hsl(var(--muted-ink))]"><Award className="h-3.5 w-3.5 text-[hsl(var(--orange))]" /> Badge on completion</div>
            <div className="mt-4"><Link to="/membership" className="btn-primary inline-flex">Start with Digital Membership</Link></div>
          </div>
        ))}
      </section>
    </main>
  );
}
